export default "__VITE_ASSET__Crf8mCdf__"